import { render, staticRenderFns } from "./linkBankAccount.vue?vue&type=template&id=2c7390c0&"
import script from "./linkBankAccount.vue?vue&type=script&lang=js&"
export * from "./linkBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports